import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { FiltroIndicadorRecuperacion } from "./Filtro/FiltroIndicadorRecuperacion";
import request from "../../../Helpers/API";
import { GetKey } from "../../../Helpers/GetKey";
import { useBox } from "../ReporteCobranza/Helper/useBox";
import Swal from "sweetalert2";
import { IndicadorSemaforoScreen } from "./IndicadorSemaforoScreen";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import PeopleIcon from "@mui/icons-material/People";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import ConstructionIcon from "@mui/icons-material/Construction";
import BalanceIcon from "@mui/icons-material/Balance";

export const IndicadorRecuperacionScreen = () => {
  const history = useHistory();
  const [boxstate, setBoxState] = useBox();
  const [data, setData] = useState({});
  const [post, setPost] = useState([]);
  const [mostrarSemaforo, setMostrarSemaforo] = useState(false);
  const [tipoCartera, setTipoCartera] = useState("");
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  // Meses del año
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  // Función para manejar los cambios de los inputs
  const handleChange = (tipoCartera, monthIndex, value) => {
    if (value > 100) {
      // Muestra una alerta si el valor es mayor a 100
      Swal.fire({
        icon: "warning",
        title: "Valor excedido",
        text: "El valor no puede ser mayor a 100. Se ajustará a 100.",
      });

      // Establecemos el valor máximo permitido (100)
      value = 100;
    }

    setData((prevData) => {
      const newData = { ...prevData };
      if (!newData[tipoCartera]) {
        newData[tipoCartera] = {
          meses: Array(12).fill(0),
          autoriza_gerencia_cobranza: false,
          autoriza_gerencia_finanzas: false,
          ejercicio: 2024,
          tipo_indicador: "RCO",
          tipo_cartera: "J",
          idIndicador: null,
        };
      }
      // Guardamos el valor del mes y mantenemos el idIndicador
      newData[tipoCartera].meses[monthIndex] = value;

      // Nos aseguramos de que el idIndicador no sea null
      newData[tipoCartera].idIndicador =
        newData[tipoCartera].idIndicador || prevData[tipoCartera]?.idIndicador;

      // Actualiza `post` directamente como un array
      setPost((prevPost) => {
        const updatedPost = [...prevPost];
        const existingIndex = updatedPost.findIndex(
          (item) => item.tipo_cartera === tipoCartera
        );

        const updatedItem = {
          idIndicador: newData[tipoCartera].idIndicador,
          tipo_indicador: newData[tipoCartera].tipo_indicador,
          tipo_cartera: newData[tipoCartera].tipo_cartera,
          ejercicio: newData[tipoCartera].ejercicio,
          enero: newData[tipoCartera].meses[0],
          febrero: newData[tipoCartera].meses[1],
          marzo: newData[tipoCartera].meses[2],
          abril: newData[tipoCartera].meses[3],
          mayo: newData[tipoCartera].meses[4],
          junio: newData[tipoCartera].meses[5],
          julio: newData[tipoCartera].meses[6],
          agosto: newData[tipoCartera].meses[7],
          septiembre: newData[tipoCartera].meses[8],
          octubre: newData[tipoCartera].meses[9],
          noviembre: newData[tipoCartera].meses[10],
          diciembre: newData[tipoCartera].meses[11],
          autoriza_gerencia_finanzas:
            newData[tipoCartera].autoriza_gerencia_finanzas,
          autoriza_gerencia_cobranza:
            newData[tipoCartera].autoriza_gerencia_cobranza,
        };

        if (existingIndex !== -1) {
          // Si ya existe un objeto con el tipoCartera, actualízalo
          updatedPost[existingIndex] = updatedItem;
        } else {
          // Si no existe, agrégalo
          updatedPost.push(updatedItem);
        }

        return updatedPost;
      });

      return newData;
    });
  };

  const onGuardar = () => {
    setLoader({ ...loader, mostrar: true });

    request
      .post("IndicadoresRecuperacion", post)
      .then(async () => {
        setLoader({ ...loader, mostrar: false });
        await Swal.fire(
          "INDICADORES RECUPERACION",
          "Se registraron los indicadores",
          "success"
        );
        setPost([]);
        onExecute(boxstate.ejercicio);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };

  // useEffect(() => {
  //     // setLoader({ ...loader, mostrar: true });
  //     onExecute(new Date().getFullYear());
  //     // setLoader({ ...loader, mostrar: false });
  // }, []);

  // Función para formatear los datos que recibes
  const formatData = (data) => {
    const formatted = {};

    data.forEach((item) => {
      const tipoCartera = item.tipo_cartera;
      formatted[tipoCartera] = {
        meses: [
          item.enero,
          item.febrero,
          item.marzo,
          item.abril,
          item.mayo,
          item.junio,
          item.julio,
          item.agosto,
          item.septiembre,
          item.octubre,
          item.noviembre,
          item.diciembre,
        ],
        autoriza_gerencia_cobranza: item.autoriza_gerencia_cobranza,
        autoriza_gerencia_finanzas: item.autoriza_gerencia_finanzas,
        ejercicio: item.ejercicio,
        usuario: item.usuario,
        tipo_indicador: item.tipo_indicador,
        tipo_cartera: item.tipo_cartera,
        idIndicador: item.idIndicador,
      };
    });

    return formatted;
  };

  const onExecute = (ejercicio) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`IndicadoresRecuperacion/Listado?ejercicio=${ejercicio}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          // console.log(result)
          if (result && Array.isArray(result)) {
            const formattedData = formatData(result);
            setData(formattedData);
          }
          setMostrarSemaforo(false);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  // Función para mostrar el componente de semáforo
  const onSemaforo = (tipo) => {
    setTipoCartera(tipo);
    setMostrarSemaforo(true); // Cambia el estado para mostrar el semáforo
  };

  //Boton Regresar
  const onBack = () => {
    //si esta en el semaforo, reresamos a la tabla anterior
    if (mostrarSemaforo !== false) {
      onExecute(boxstate.ejercicio);
      setMostrarSemaforo(false);
    } else {
      history.push("/Creditoycobranza/Main");
    }
  };

  return (
    <PlantillaScreen
      titulo={
        mostrarSemaforo === true && tipoCartera === "O"
          ? "SEMAFORO OPERACION " + boxstate.ejercicio
          : mostrarSemaforo === true && tipoCartera === "E"
          ? "SEMAFORO ESPECIAL " + boxstate.ejercicio
          : mostrarSemaforo === true && tipoCartera === "R"
          ? "SEMAFORO REVOLVENTE " + boxstate.ejercicio
          : mostrarSemaforo === true && tipoCartera === "J"
          ? "SEMAFORO JURIDICO " + boxstate.ejercicio
          : "INDICADORES DE RECUPERACION " + boxstate.ejercicio
      }
      className={"indicadores-recuperacion-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="indicador-recuperacion-boton-regresar-container">
        <div className="back" onClick={() => onBack()}>
          <ArrowBackIcon />
          Regresar
        </div>
      </div>
      <div className="indicador-recuperacion-boton-filtro-container">
        <div className="filtro">
          <FiltroIndicadorRecuperacion
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
          />
        </div>
      </div>

      {mostrarSemaforo === false && (
        <div className="indicador-recuperacion-tabla-main-container scroll">
          <table
            cellPadding={0}
            cellSpacing={0}
            // border="1"
          >
            <thead>
              <tr>
                <th>Tipo</th>
                {meses.map((mes, index) => (
                  <th key={index}>{mes}</th>
                ))}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(data).map((tipoCartera, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {tipoCartera === "OP" || tipoCartera === "OV" ? (
                        <AgricultureIcon style={{ marginRight: "8px" }} />
                      ) : tipoCartera === "RP" || tipoCartera === "RV" ? (
                        <ConstructionIcon style={{ marginRight: "8px" }} />
                      ) : tipoCartera === "EP" || tipoCartera === "EV" ? (
                        <PeopleIcon style={{ marginRight: "8px" }} />
                      ) : tipoCartera === "JP" || tipoCartera === "JV" ? (
                        <BalanceIcon style={{ marginRight: "8px" }} />
                      ) : (
                        <></> // Si no hay coincidencia, no muestra ícono
                      )}
                      {tipoCartera === "OP"
                        ? "Operación por vencer"
                        : tipoCartera === "OV"
                        ? "Operación vencida"
                        : tipoCartera === "RP"
                        ? "Revolvente por vencer"
                        : tipoCartera === "RV"
                        ? "Revolvente vencida"
                        : tipoCartera === "EP"
                        ? "Especial por vencer"
                        : tipoCartera === "EV"
                        ? "Especial vencida"
                        : tipoCartera === "JP"
                        ? "Juridico por vencer"
                        : tipoCartera === "JV"
                        ? "Juridico vencido"
                        : "Sin identificar"}
                    </div>
                  </td>
                  {data[tipoCartera].meses.map((value, monthIndex) => (
                    <td key={monthIndex}>
                      <input
                        type="number"
                        value={value}
                        onChange={(e) =>
                          handleChange(tipoCartera, monthIndex, e.target.value)
                        }
                        placeholder="%" // Indicando que es un porcentaje
                        // style={{ width: '80px', textAlign: 'center' }}
                      />
                    </td>
                  ))}
                  <td>
                    <button
                      className="indicador-recuperacion-ir-semaforo"
                      onClick={() => onSemaforo(tipoCartera)}
                    >
                      Semaforo
                      <ArrowForwardIcon />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {Object.keys(post).length > 0 && (
        <div className="indicador-recuperacion-boton-guardar-container">
          <button
            className="indicador-recuperacion-boton-guardar"
            onClick={() => onGuardar()}
          >
            <SaveIcon />
            Guardar
          </button>
        </div>
      )}
      {/* Condicionalmente mostramos el componente IndicadorSemaforoScreen */}
      {mostrarSemaforo && (
        <div>
          <IndicadorSemaforoScreen
            boxstate={boxstate}
            tipoCartera={tipoCartera}
          />
        </div>
      )}
    </PlantillaScreen>
  );
};
